import React from "react"
import { Toaster } from "./src/components/ui/toaster"
import { Toaster as Sonner } from "./src/components/ui/sonner"
import { TooltipProvider } from "./src/components/ui/tooltip"
import { ThemeProvider } from "next-themes"
import { Layout } from "./src/components/Layout"
import "./src/index.css"

// Prism.js for code blocks in markdown
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-bash"
import "prismjs/components/prism-typescript"
import "prismjs/components/prism-javascript"
import "prismjs/components/prism-jsx"
import "prismjs/components/prism-tsx"
import "prismjs/components/prism-json"
import "prismjs/components/prism-yaml"
import "prismjs/components/prism-markdown"
import "prismjs/components/prism-python"

/**
 * Implement Gatsby's Browser APIs in this file.
 */
export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <TooltipProvider>
        {element}
        <Toaster />
        <Sonner />
      </TooltipProvider>
    </ThemeProvider>
  )
}

export const wrapPageElement = ({ element }) => {
  return React.createElement(Layout, null, element)
}
